import { IconProps } from './types';

export default function LocationPin({ className, strokeWidth }: IconProps) {
    return (
        <svg
            fill="none"
            className={className}
            height="25"
            viewBox="0 0 24 25"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            role="img"
            strokeWidth={strokeWidth}
        >
            <g
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="m12.1539 13.6155c1.3595 0 2.4616-1.1021 2.4616-2.4616 0-1.35945-1.1021-2.46152-2.4616-2.46152-1.3594 0-2.46152 1.10207-2.46152 2.46152 0 1.3595 1.10212 2.4616 2.46152 2.4616z" />
                <path d="m18.3077 11.1538c0 5.5385-6.1539 9.8462-6.1539 9.8462s-6.1538-4.3077-6.1538-9.8462c0-1.63206.64835-3.19731 1.80242-4.35138s2.71928-1.80242 4.35138-1.80242 3.1974.64835 4.3515 1.80242c1.154 1.15407 1.8024 2.71932 1.8024 4.35138z" />
            </g>
        </svg>
    );
}
